export default __webpack_public_path__ + "static/media/sunbettery.76bc5176.png";